<template>
  <div class="col-auto">
    <q-inner-loading
      style="z-index: 1;"
      :showing="loading"
    />
    <model-table
      title="Adjustments"
      :collection="inventoryItemAdjustments"
      :columns="[
        { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
        { name: 'location', label: 'Location', field: 'locationOrRegisterStationDisplayValue', align: 'left' },
        { name: 'quantity', field: 'baseQuantity' },
        { field: 'adjustmentType' },
        { name: 'committedAt', field: row => row.committedAt ? row.committedAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'actions', align: 'right' }
      ]"
      :initial-limit="5"
      sort-by="createdAt"
      edit-label="View"
      :constructor-data="{ inventoryItemId: inventoryItemId }"
      @change="$emit('change')"
    >
      <inventory-item-adjustment-form />
    </model-table>
  </div>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import InventoryItemAdjustmentForm from 'src/modules/admin/inventory-item/components/InventoryItemAdjustmentForm'

export default {
  name: 'InventoryItemAdjustmentTable',
  components: {
    ModelTable,
    InventoryItemAdjustmentForm
  },
  configuration: ['registerStations', 'currentCircuit'],
  props: {
    inventoryItemId: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  models: {
    inventoryItemAdjustments: {
      variables () {
        return {
          inventoryItemId: this.inventoryItemId,
          limit: 5
        }
      },
      immediate: true
    }
  },
  emits: ['change']
}

</script>
